import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css'
import BusinessCard from '../components/Cards/BusinessCard';
import Hero from '../components/Hero';
import Section from '../components/Section';

import heroImgSrc from 'assets/images/Building-Good-in-2020-scaled.jpg'
import InputWithLogo from 'components/InputWithLogo';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import axios from 'utils/axios';
import {Blog, WelcomePage} from 'utils/types'
import resolveImgUrl from 'utils/resolveImgUrl';
import Spinner from 'components/utils/Spinner';
import { Button, Input } from '@material-tailwind/react';
import { Link, useNavigate } from 'react-router-dom';
import {motion, useScroll} from 'framer-motion'
import { useMediaQuery } from 'react-responsive';

import userImg from 'assets/images/user.svg';


const Index = ()=>{
    const navigate = useNavigate();

    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

    const {data : welcomePageMeta, status : welcomePageStatus} = useQuery(['welcomePageMeta'], async()=>{
        const {data} = await axios.get(`site/welcome-page`);
        return data as WelcomePage.Type;
    })

    
    const {data : blogs, status : blogsStatus, error : blogsError, refetch : refetchBlogs} = useQuery(["blogs", "editor-picks"],  async()=>{
      const {data} = await axios.get(`blogs/editor-picks`);
      return data as Blog[]
  })
    
    if(welcomePageStatus === 'loading')
        return <div className='min-h-screen grid place-content-center'>
            <Spinner twWidthHeight="w-20 h-20"></Spinner>
        </div>
    if(welcomePageStatus === 'error')
        return <div className='min-h-screen grid place-content-center'>
            <div className="flex flex-col items-center gap-y-2">
                <i className="fas fa-circle-exclamation text-3xl"></i>
                <div className="text-8xl font-semibold">
                    {/* @ts-ignore */}
                    {error.response?.status || 'Something went wrong'}
                </div>
            </div>
        </div>
    else
    return (
        <>
        <Hero imgOverlayOpacity={0.5} imgUrl={heroImgSrc}
            bottomChildren={
                <>
                    <div className='absolute bottom-0 h-14 w-full bg-gradient-to-b from-[#00000000] to-90% to-[#000000]'></div>
                    <div className='absolute -bottom-5 left-1/2 transform -translate-x-1/2 w-10 h-10 rounded-full border border-white grid place-content-center text-white'>
                        <i className="fa-solid fa-chevron-down"></i>
                    </div>
                </>
            }
        >
            <>
                <div className='absolute top-0 w-full h-full text-center flex flex-col justify-center items-center text-white font-semibold gap-y-5'>
                    <Section>
                        <div className='banner-text text-3xl md:text-5xl xl:text-6xl' dangerouslySetInnerHTML={{__html : (welcomePageMeta?.heroText || '')}}></div>
                    </Section>
                </div>
            </>
        </Hero>
        <div className=' flex flex-col gap-y-10'>
            <div className='bg-black'>
                <Section className='text-white flex-col flex py-32 relative'>
                    <>
                    <motion.h2 viewport={{amount:0.8, once:true}} className="transition ease-out text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold text-center" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}} 
                      dangerouslySetInnerHTML={{__html: (welcomePageMeta.firstSection?.title || '')}}
                    />
                    <motion.p viewport={{amount:0.8, once:true}} className="transition ease-out text-gray-300 self-center text-center xl:w-2/3 mt-7" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}
                      dangerouslySetInnerHTML={{__html: (welcomePageMeta.firstSection?.description || '')}}
                    />
                    <div className='grid lg:grid-cols-3 gap-x-4 gap-y-6 mt-20'>
                      {
                        welcomePageMeta.firstSectionItems?.map((card, i)=>(
                          <motion.div key={i} viewport={{amount:0.8, once:true}} className="transition ease-out h-full" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}>
                              <motion.div viewport={{amount:'all'}} initial={{backgroundColor : ''}} whileInView={{backgroundColor : isMobile ? '#ffffff10' : ''}} className='h-full bg-gradient-to-br from-[#ffffff07] to-[#ffffff22] hover:bg-[#ffffff10] transition-all transform lg:hover:-translate-y-5 p-10 flex flex-col gap-y-2 rounded-md'>
                                  <div className='bg-white bg-opacity-20 w-14 h-14 grid place-content-center rounded-md text-2xl'>
                                      <i className={
                                        (card.iconType === "regular" ? "far" :  "fas") + " fa-" + (card.icon || "fa-circle-unknown")
                                      }/>
                                  </div>
                                  <h3 className='mt-3 text-lg md:text-xl xl:text-2xl font-bold' 
                                    dangerouslySetInnerHTML={{
                                      __html : card.title || ''
                                    }}
                                  />
                                  <span className='text-sm md:text-base'
                                    dangerouslySetInnerHTML={{
                                      __html : card.description || ''
                                    }}
                                  />
                              </motion.div>
                          </motion.div>
                        ))
                      }
                    </div>
                    <div className='p-4 bg-white grid md:grid-cols-2 gap-4 absolute -bottom-10 left-1/2 transform -translate-x-1/2 rounded-md w-[90%] lg:w-auto'>
                        
                    </div>
                    </>
                </Section>
            </div>
            <Section className='flex flex-col py-24'>
                <>
                    <motion.h2 viewport={{amount:0.8, once:true}} className="transition ease-out text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold text-center" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}
                      dangerouslySetInnerHTML={{__html: (welcomePageMeta.secondSection?.title || '')}}
                    />
                    <motion.p viewport={{amount:0.8, once:true}} className="transition ease-out text-gray-600 self-center text-center xl:w-2/3 mt-7" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}
                      dangerouslySetInnerHTML={{__html: (welcomePageMeta.secondSection?.description || '')}}
                    />
                    <div>
                        {(blogsStatus === 'loading' &&
                    <div className='h-24 grid place-content-center my-4'>
                        <Spinner twWidthHeight='w-20 h-20'></Spinner>
                    </div>
                        )}
                        {(blogsStatus === 'error' &&
                    <div className='h-24 grid place-content-center my-4'>
                        <div className="flex flex-col items-center gap-y-2">
                            <i className="fas fa-circle-exclamation text-3xl"></i>
                            <div className="text-xl font-semibold">
                                {/* @ts-ignore */}
                                {blogsError.response?.status || "Something Went Wrong"}
                            </div>
                            <Button onClick={()=>refetchBlogs()}>
                                Reload
                            </Button>
                        </div>
                    </div>
                        )}
                        {(blogsStatus === 'success' && <>
                            <div className='flex justify-end mt-10'>
                                <motion.div viewport={{amount:0.8, once:true}} className="transition ease-out" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}>
                                    <Link to='/blogs/'>
                                        <button className='text-blue-500 flex items-center gap-2'>
                                            <span> Lihat semua </span>
                                            <div className='w-8 h-8 rounded-full border border-blue-500 grid place-content-center text-blue-500 text-sm'>
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </div>
                                        </button>
                                    </Link>
                                </motion.div>     
                            </div>
                            <div className='grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-3'>
                                {blogs.map(
                                    business=><motion.div key={business.id} viewport={{amount:0.8, once:true}} className="transition ease-out" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}>
                                            <BusinessCard 
                                                imgUrl={resolveImgUrl(business.imgUrl, true)} 
                                                title={business.title}
                                                to={'/bisnis-lokal/'+business.slug}
                                            />
                                            </motion.div>
                                )}
                            </div>
                        </>
                        )}
                    </div>
                </>
            </Section>
            <div className='bg-gray-100'>
                <Section className='flex flex-col py-24'>
                    <motion.h2 viewport={{amount:0.8, once:true}} className="transition ease-out text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold text-center" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}
                      dangerouslySetInnerHTML={{__html: (welcomePageMeta.testimonySection?.title || '')}}
                    />
                    <motion.p viewport={{amount:0.8, once:true}} className="transition ease-out text-gray-600 self-center text-center xl:w-2/3 mt-7" initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}
                      dangerouslySetInnerHTML={{__html: (welcomePageMeta.testimonySection?.description || '')}}
                    />
                    <div className='grid lg:grid-cols-2 xl:grid-cols-3 lg:grid-rows-2 gap-4 mt-20 text-white'>
                        {welcomePageMeta.testimonySectionItems?.map((el, i)=>(
                          <motion.div viewport={{amount:0.8, once:true}} key={i} className={ (i === 0 ? "lg:row-span-2" : "xl:col-span-2" )+ " transition ease-out bg-black p-10 flex flex-col gap-y-2 rounded-xl"} initial={{opacity:0, transform:"translateY(20px)"}} whileInView={{opacity:1, transform:'translateY(0px)'}}>
                            <div className='flex gap-3 items-center'>
                              <div className="rounded-full w-16 h-16 group relative overflow-hidden cursor-pointer">
                                <img src={el.image ? resolveImgUrl(el.image): userImg} className="w-full h-full rounded-full object-cover" alt="" />
                              </div>
                              <div className='flex flex-col font-semibold text-lg'>
                                  <span>{el.name}</span>
                                  <span className='text-blue-500'>@{el.username}</span>
                              </div>
                            </div>
                            <span className='text-gray-300 mt-7'
                              dangerouslySetInnerHTML={{__html: el.description}}
                            />
                          </motion.div>
                        ))}
                    </div>
                </Section>
            </div>

        </div>
        </>
    )
}

export default Index;